
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart-home-panel",
      function () {
        return require("private-next-pages/smart-home-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart-home-panel"])
      });
    }
  